import { render, staticRenderFns } from "./PartOfSpeachHeader.vue?vue&type=template&id=2ab97eae&"
import script from "./PartOfSpeachHeader.vue?vue&type=script&lang=js&"
export * from "./PartOfSpeachHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports